// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

import { reelsReachConfig } from '../reelsReach';

export const reelsReachMVConfig: KpiType<typeof MediaViewerKpiLoader, typeof MediaViewerKPI> = {
    ...reelsReachConfig,
    name: 'kpi.facebook.reach',
    id: 'reach',
    tooltip: null,
    size: SIZE_50,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
